import React from "react";
import {calcResource, lgSetup} from "../../backend/LgSetup";

export function Admin() {
    return (

        <div style={{width: 1000 + 'px'}}>
            <table ><tbody>
                {Object.values(lgSetup.products).map(product => {
                        let image = calcResource(product["path"], product["miniposterResource"])
                        let hide = product.productCode.includes("TEST_") || product.productCode.includes("UNKNOWN") || product.productCode.includes("RECORDING")
                        if (hide)
                            return <tr key={product.productCode}></tr>
                        else
                        return <tr key={product.productCode} >
                            <td>
                                <a href={"begin?productCode=" + product.productCode + "&lng=ru"}>{product.productCode}</a>
                            </td>
                            <td>
                                <a href={"begin?productCode=" + product.productCode + "&lng=ru&priceNote=Наличные!"}>RU </a>
                                <a href={"begin?productCode=" + product.productCode + "&lng=et&priceNote=Sularaha!"}>ET </a>
                                <a href={"begin?productCode=" + product.productCode + "&lng=uk&priceNote=Готівка!"}>UK </a>
                                <a href={"begin?productCode=" + product.productCode + "&lng=lv&priceNote=Skaidra nauda!"}>LV </a>
                                <a href={"begin?productCode=" + product.productCode + "&lng=lt&priceNote=Grynaisiais!"}>LT </a>
                            </td>
                        </tr>
                    }
                )}
            </tbody></table>
            <br/>
        </div>
    );
}
